import React, {Component} from 'react';
import { connect } from 'react-redux';
import agent from '../agent'
//import { Cookies } from 'react-cookie' 
//import { TOKEN_NAME, BASE_IMAGE } from '../constants/actionTypes';
import '../styles/main.css'
import '../styles/responsive.css';
import LocalizedStrings from 'react-localization';
import Menu from './language/menu.js';
import SystemCheckUp from './Home/SystemCheckUp';

const mapStateToProps = state => (
    Object.assign({}, state, {
		
		language_key: state.common.language_key,
	})      
);

const mapDispatchToProps = dispatch => ({               
	
	
});
let sMenu=new LocalizedStrings(Menu);
class Footer extends Component{    
	constructor() {
        super();
		
        this.state = {	
			show_app_links:1
			,help_link:'',language:'en',
			show_system_checkup: false
        }		
		this.getSchoolbyIDs=(school_id)=>{
			//let school_id=this.state.student_id
			agent.auth.get_school_byid(school_id,{}).then(datas => {
				//console.log(datas)
				if(datas.status===true){
					let data=datas.data;
					let show_app_links=(data!==undefined && data!==null && data!=='')?data.show_app_links:''
					let help_link=(data!==undefined && data!==null && data!=='')?data.help_link:''
					this.setState({show_app_links:show_app_links,help_link:help_link},()=>{
						
					})
				}
			})
					
		}
		this.showSystemCheckUp = () => {
			this.setState({show_system_checkup: true});
		}
		this.hideSystemCheckUp = () => {
			this.setState({show_system_checkup: false});
		}
		this.zendesksso=()=>{
			agent.admin.zendesksso({}).then(datas => {				
				if(datas){					
					window.open(datas, '_blank');
				}
					
			});
		}
	}
    componentWillReceiveProps(nextProps) {
		if(nextProps && nextProps.language_key){
			this.setState({language:nextProps.language_key,})
		}
	}
	componentWillMount() {
		//const cookies = new Cookies()
		let language=window.localStorage.getItem('language');
		if(language!=undefined && language!=null && language!=''){
			this.setState({language:language});
		}
		let userInfo=window.localStorage.getItem('USERLOG');
		 if(userInfo!==undefined && userInfo!==null && userInfo!==''){			
			userInfo=JSON.parse(userInfo);		 
			let last_school_id=userInfo.last_school_id
			this.getSchoolbyIDs(last_school_id);
		 }	
	}	
	handleFiled(e){
	}
    render(){        
		let show_app_links=this.state.show_app_links;
		let help_link=this.state.help_link;
		sMenu.setLanguage(this.state.language);
			return (
				<footer className="footer-area">
					<div className="container">
						<div className="footer-content">
							<div className="single-footer-content">
								<div className="footer-logo">
									<a href="#"><img src="/media/home/footer-logo.png" alt="Images" /></a>
								</div>
								<div className="footer-links">
									{/*<ul>
										<li><a href="/home">Home</a></li>
										<li><a href="/discussions">Discussions</a></li>
										<li><a href="/schedule">My Schedule</a></li>
									</ul>*/}
									{(show_app_links==1)?
									<div className="mu_footer_btn" style={{'marginTop':'2px'}}>
										<a href="https://apps.apple.com/us/app/adls-assist/id1519151671"><img src="/media/resource-cards/footer_btn_1.png" /></a>
										<a href="https://play.google.com/store/apps/details?id=com.advantagesdls.app"><img src="/media/resource-cards/footer_btn_2.png" /></a>
									
									</div>
									:''
									}
								</div>
							</div>
							
							<div className="single-footer-content">
								<div className="footer-links">
								{/*<ul>
										<li><a href="#">My course enrollment</a></li>
										<li><a href="/learning">Learning Path</a></li>
										<li><a href="/progress-tracking">Progress Tracking</a></li>
								</ul>*/}
								</div>
							</div>
							
							<div className="single-footer-content">
								<div className="footer-links">
									{/*<ul>
										<li><a href="#">Account Options</a></li>
										<li><a href="/discussions">Discussions</a></li>
										<li><a href="/schedule">My Schedule</a></li>
									</ul>*/}
								</div>
							</div>
							
							<div className="single-footer-content">
								<div className="need-help-content">
									<div className="contact-button mb-2">
										<a onClick={this.zendesksso.bind(this)}>{sMenu.contact_support}</a>
									</div>
									<div className="contact-button" onClick={this.showSystemCheckUp.bind(this)}>
										<a href={'#'}>Run System Check-Up</a>
									</div>
								</div>
							</div>
							
						</div>
						{this.state.show_system_checkup &&
							<SystemCheckUp onCallback={this.hideSystemCheckUp} />
						}

						<div className="copyright-text">
							<p>2021 © ASSIST / {sMenu.all_right_reserved} / <a target="_blank" href="/media/login/ASSIST_Privacy_Policy.pdf">{sMenu.privacy}</a> / <a target="_blank" href="/media/login/Terms_of_Use.pdf">{sMenu.terms_of_use}</a></p>
						</div>
					</div>
				</footer>					
			);			
		
    }
}

//export default Footer;

export default connect(mapStateToProps, mapDispatchToProps)(Footer)